import React, { ReactElement, useEffect } from 'react';
import { useAppToolchain } from 'src/hooks/useAppToolchain';

function OidcSigninRenew(): ReactElement {
	const { oidcUserManager } = useAppToolchain();

	useEffect(() => {
		oidcUserManager.signinSilentCallback().then(() => {
			if (window && window.history && window.location) {
				const url = new URL(window.location.href);
				url.searchParams.delete('code');
				url.searchParams.delete('state');
				url.searchParams.delete('session_state');
				window.history.replaceState({}, document.title, url.pathname + url.search);
			}
		}).catch((err) => {
			console.error('Silent signin callback failed:', err);
		});
	}, []);

	return <p>Session Renewed</p>;
}

export default OidcSigninRenew;
